import './locales/register'
import { lazy } from 'react'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import RequireSuperAdmin from '@/components/Guard/RequireSuperAdmin'
import { RouteObject } from 'react-router-dom'

const RegulationsList = lazy(() => import('./components/Regulations'))
const TechnicalTemplatesList = lazy(
    () => import('./components/TechnicalTemplates')
)
const ProductServiceManagement = lazy(
    () => import('./components/ProductServiceManagement')
)
const DataAccessList = lazy(() =>
    import('./components/DataAccess').then((m) => ({
        default: m.DataAccessList,
    }))
)
const CreateEditDataAccess = lazy(() =>
    import('./components/DataAccess').then((m) => ({
        default: m.CreateEditDataAccess,
    }))
)
// Routes of other modules that are mounted under /settings. Settings does not
// import them: src/app/register-settings.tsx passes them in.
type SettingsSlots = {
    slaTemplates: RouteObject[]
    authorization: RouteObject
}

export const createSettingsModule = ({
    slaTemplates,
    authorization,
}: SettingsSlots): RouteObject => ({
    path: 'settings',
    children: [
        {
            path: 'service-templates',
            element: <TechnicalTemplatesList />,
        },
        {
            path: 'regulations',
            element: <RegulationsList />,
        },
        ...slaTemplates,
        {
            path: 'product-services',
            element: <ProductServiceManagement />,
        },
        // Authorization management (resources, scopes, permissions, policies)
        authorization,
        // Data Access Assignments — super_admin only
        {
            path: 'data-access',
            element: (
                <RequireSuperAdmin>
                    <DataAccessList />
                </RequireSuperAdmin>
            ),
        },
        {
            path: 'data-access/new',
            element: (
                <RequireSuperAdmin>
                    <CreateEditDataAccess />
                </RequireSuperAdmin>
            ),
        },
        {
            path: 'data-access/:id/edit',
            element: (
                <RequireSuperAdmin>
                    <CreateEditDataAccess />
                </RequireSuperAdmin>
            ),
        },
    ],
    errorElement: <ErrorPage status={500} />,
})
